import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { useTranslation, TranslateFn } from '@blocs.i18n';
import { helpers } from '@minecraft.utils';
import { gqlTalentProfileUnion, gqlOrganization } from '@minecraft.graphql-types';

const Title = styled.h1`
  margin: 0;
  font-size: 1.875rem;
`;

const ProfileInfoItem = styled.div`
  margin-top: 0.625rem;
`;

type Props = {
  isPersonal?: boolean;
  stageName: string;
  talentUnions: ReadonlyArray<gqlTalentProfileUnion>;
  profileMainOrganization?: gqlOrganization;
  profileMainDivision?: gqlOrganization;
};

const getRepCompanyName = (
  { isPersonal, profileMainOrganizationName, profileMainDivisionName },
  t: TranslateFn
): string => {
  if (isPersonal) return t('common:label.personalProfile');

  const mainOrganizationName = `${profileMainOrganizationName} ${
    profileMainDivisionName ? `(${profileMainDivisionName})` : ''
  }`;

  return profileMainOrganizationName ? mainOrganizationName : '';
};

const SummaryProfileInfo: FC<Props> = ({
  isPersonal,
  stageName,
  talentUnions,
  profileMainOrganization,
  profileMainDivision,
}) => {
  const { t } = useTranslation();

  const repCompanyName = getRepCompanyName(
    {
      isPersonal,
      profileMainOrganizationName: profileMainOrganization?.name,
      profileMainDivisionName: profileMainDivision?.name,
    },
    t
  );

  return (
    <div>
      <Title>{stageName}</Title>
      {repCompanyName && <ProfileInfoItem>{repCompanyName}</ProfileInfoItem>}
      <ProfileInfoItem>
        {talentUnions.length > 0 ? helpers.getUnionsString(talentUnions || null, null) : t('common:profile.nonUnion')}
      </ProfileInfoItem>
    </div>
  );
};

export default memo<Props>(SummaryProfileInfo);
